var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18C18 16.8635 17.5688 15.7731 16.8021 14.9692C16.0347 14.166 14.9939 13.7143 13.9091 13.7143H4.09091C3.00609 13.7143 1.96527 14.166 1.19787 14.9692C0.431205 15.7731 0 16.8635 0 18V19.7143C0 20.8508 0.431191 21.9411 1.19787 22.7451C1.96527 23.5483 3.00609 24 4.09091 24H13.9091C14.9939 24 16.0347 23.5483 16.8021 22.7451C17.5688 21.9411 18 20.8508 18 19.7143V18ZM9 0C5.83939 0 3.27273 2.68888 3.27273 6C3.27273 9.31112 5.83939 12 9 12C12.1606 12 14.7273 9.31112 14.7273 6C14.7273 2.68888 12.1606 0 9 0Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.3976d441e1477cc3c8c3fedb69445f16.svg";
export { ForwardRef as ReactComponent };